import { CurrencyTokenType, useCurrencyContext } from '@apeiron/currency'
import { useWeb3 } from '@apeiron/temp'
import { useCallback } from 'react'

const useGetAuctionPrice = (): Hook => {
  const { toWei, fromWei } = useWeb3()

  const { getCurrency } = useCurrencyContext()

  const getCurrentPrice = useCallback(
    (params: CurrentPriceParams) => {
      const { currencyType, duration, endPrice, startDate, startPrice } = params

      if (duration <= 0) {
        return Math.max(startPrice, endPrice)
      } else {
        const durationInTimestamp = duration * 1000

        const startToNow = Math.min(
          Date.now() - new Date(startDate).getTime(),
          durationInTimestamp
        )

        const startToEnd = durationInTimestamp || 1

        const currency = getCurrency(currencyType)

        const decimal = currency?.decimals || 18

        return parseFloat(
          fromWei(
            ((BigInt(toWei(endPrice, decimal)) -
              BigInt(toWei(startPrice, decimal))) *
              BigInt(startToNow)) /
              BigInt(startToEnd) +
              BigInt(toWei(startPrice, decimal)),
            decimal
          )
        )
      }
    },
    [fromWei, getCurrency, toWei]
  )

  return {
    getCurrentPrice
  }
}

type CurrentPriceParams = {
  currencyType: CurrencyTokenType
  duration: number
  endPrice: number
  startDate: Date
  startPrice: number
}

type Hook = {
  getCurrentPrice: (params: CurrentPriceParams) => number
}

export default useGetAuctionPrice
